import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function PaperUpload({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <PaperUpload.Outline {...props} />
  ) : (
    <PaperUpload.Solid {...props} />
  );
}

PaperUpload.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M9.82809 12.7934L10.8909 11.7261V15.9497C10.8909 16.3639 11.2267 16.6997 11.6409 16.6997C12.0551 16.6997 12.3909 16.3639 12.3909 15.9497V11.7245L13.4552 12.7934C13.7474 13.0869 14.2223 13.0879 14.5158 12.7956C14.8093 12.5034 14.8104 12.0285 14.5181 11.735L12.1731 9.37998C12.145 9.35176 12.1148 9.32598 12.083 9.30281C11.959 9.21218 11.8062 9.15869 11.6409 9.15869C11.42 9.15869 11.2215 9.25413 11.0843 9.406L8.76517 11.735C8.4729 12.0285 8.47391 12.5034 8.76743 12.7956C9.06095 13.0879 9.53582 13.0869 9.82809 12.7934Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6078 2.01175C14.5647 2.00403 14.5202 2 14.4749 2C14.4295 2 14.3851 2.00403 14.3419 2.01175H8.08603C5.59836 2.00298 3.56066 3.98507 3.50087 6.47272L3.50065 6.49075V17.2201C3.45139 19.7326 5.44639 21.8108 7.95859 21.8646L7.97465 21.8647L7.9838 21.8648C8.00449 21.865 8.05386 21.8655 8.09278 21.8647H16.0726C16.0815 21.8647 16.0903 21.8646 16.0992 21.8643C18.5938 21.776 20.5657 19.7212 20.5527 17.2259V8.03775C20.5527 7.84411 20.4778 7.65797 20.3436 7.51829L15.2776 2.24229C15.1362 2.095 14.9408 2.01175 14.7366 2.01175H14.6078ZM17.0417 8.984C15.2088 8.97883 13.7249 7.49286 13.7249 5.659V3.51175H8.08176C6.41296 3.50533 5.04528 4.8324 5.00065 6.50024V17.2277L5.00048 17.2438C4.9644 18.9291 6.29982 20.3247 7.98337 20.3648C8.01018 20.3648 8.02455 20.365 8.03456 20.3651C8.04598 20.3653 8.05173 20.3654 8.06382 20.365L8.08465 20.3647H16.0587C17.7373 20.2987 19.0623 18.9134 19.0527 17.2321L19.0526 17.2277V8.984H17.0439L17.0417 8.984ZM15.2249 4.35306L18.2312 7.484H17.045C16.0384 7.48066 15.2249 6.66483 15.2249 5.659V4.35306Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

PaperUpload.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
